import * as am5 from '@amcharts/amcharts5'
import * as am5percent from '@amcharts/amcharts5/percent'
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated'
import React, { useLayoutEffect } from 'react'

const _getTokenPrice = (tokens) => (tokens - 1) * 0.000000003725
const _formatPrice = (price) => price.toFixed(2)

export const EmissionDiagram = ({ tokenData, goldData }) => {
  const lastTokenEmitted = Math.ceil(tokenData[0].amount)
  const nextTokenToEmit = lastTokenEmitted + 1
  const lastTokenGoldPrice = _getTokenPrice(lastTokenEmitted)
  const nextTokenGoldPrice = _getTokenPrice(nextTokenToEmit)

  // Chart Default Settings
  const newPieChartSetting = {
    startAngle: -180,
    endAngle: 0,
    innerRadius: am5.percent(65),
  }

  const seriesSetting = {
    name: 'Series',
    valueField: 'amount',
    categoryField: 'category',
    startAngle: -180,
    endAngle: 0,
    legendLabelText: '{category}:',
  }

  const sliceTemplateSetting = {
    stroke: am5.color('#fff'),
    strokeWidth: 2,
    strokeOpacity: 0.4,
    toggleKey: 'none',
  }

  const labelsSetting = {
    centerX: am5.percent(50),
    centerY: am5.percent(100),
    populateText: true,
    fontWeight: 'bold',
    textAlign: 'center',
    // fontSize: "125%"
  }

  const legendSetting = {
    x: am5.percent(50),
    centerX: am5.percent(50),
  }

  useLayoutEffect(() => {
    // ====> create Root
    const root = am5.Root.new('chartdiv')
    root.setThemes([am5themes_Animated.new(root)])

    // ====> create Chart
    let chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        ...newPieChartSetting,
        layout: root.verticalLayout,
      }),
    )

    chart.getNumberFormatter().set('numberFormat', '#.####a')

    // ====> Create series
    let series = chart.series.push(
      am5percent.PieSeries.new(root, {
        ...seriesSetting,
        legendValueText: '[bold]{value}[/] QRFID',
      }),
    )

    series
      .get('colors')
      .set('colors', [am5.color('#419d8d'), am5.color('#9fe0ea')])

    series.ticks.template.set('forceHidden', true)
    series.labels.template.set('forceHidden', true)

    series.slices.template.setAll({
      ...sliceTemplateSetting,
    })

    series.children.push(
      am5.Label.new(root, {
        ...labelsSetting,
        text: 'QRFID Tokens:\n{valueSum}',
      }),
    )

    series.appear(600)
    chart.appear(200)

    series.data.setAll(tokenData)

    // Add legend
    let legend = chart.children.push(
      am5.Legend.new(root, {
        ...legendSetting,
        layout: root.verticalLayout,
      }),
    )

    legend.data.setAll(series.dataItems)

    return () => {
      root.dispose()
    }
  }, [])

  useLayoutEffect(() => {
    // ====> create Root
    const root = am5.Root.new('chartdiv1')
    root.setThemes([am5themes_Animated.new(root)])

    // ====> create Chart
    let chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        ...newPieChartSetting,
        layout: root.verticalLayout,
      }),
    )

    // ====> Create series
    let series = chart.series.push(
      am5percent.PieSeries.new(root, {
        ...seriesSetting,
        legendValueText: '[bold]{value}[/] Kg',
      }),
    )

    series
      .get('colors')
      .set('colors', [am5.color('#d07a00'), am5.color('#f2f695')])

    series.ticks.template.set('forceHidden', true)
    series.labels.template.set('forceHidden', true)

    series.slices.template.setAll({
      ...sliceTemplateSetting,
    })

    series.children.push(
      am5.Label.new(root, {
        ...labelsSetting,
        text: 'Gold KG:\n{valueSum} Kg',
      }),
    )

    series.appear(600)
    chart.appear(200)

    series.data.setAll(goldData)

    // Add legend
    let legend = chart.children.push(
      am5.Legend.new(root, {
        ...legendSetting,
        layout: root.verticalLayout,
      }),
    )

    legend.data.setAll(series.dataItems)

    return () => {
      root.dispose()
    }
  }, [])

  return (
    <>
      <div className="row row-cols-1 row-cols-md-2 m-3">
        <div
          id="chartdiv"
          className="col"
          style={{ width: '100%', minHeight: '300px' }}
        ></div>
        <div
          id="chartdiv1"
          className="col"
          style={{ width: '100%', minHeight: '300px' }}
        ></div>
      </div>
      <div className="row row-cols-1 row-cols-md-2 mt-3 px-6">
        <div className=" col mt-3 lst-em-token">
          <h4>Last Token Emitted</h4>
          <div>
            Token Number:{' '}
            <span style={{ fontWeight: 'bold' }}>{lastTokenEmitted}</span>
          </div>
          <div>
            Token Gold Price:{' '}
            <span style={{ fontWeight: 'bold' }}>
              {lastTokenGoldPrice} grams
            </span>
          </div>
          <div style={{ fontSize: '1.2rem', fontWeight: 800 }}>
            Token price: {_formatPrice(lastTokenGoldPrice * 61.74)} USD
          </div>
        </div>
        <div className="col mt-3 nxt-em-token">
          <h4>Next Token to be Emitted</h4>
          <div>
            <span style={{ fontWeight: 'bold' }}>Token Number:</span>{' '}
            {nextTokenToEmit}
          </div>
          <div>
            <span style={{ fontWeight: 'bold' }}>Token Gold Price:</span>{' '}
            {nextTokenGoldPrice} grams
          </div>
          <div style={{ fontSize: '1.2rem', fontWeight: 800 }}>
            Token Price: {_formatPrice(nextTokenGoldPrice * 61.74)} USD
          </div>
        </div>
      </div>
    </>
  )
}
